import { Suspense, createElement, useEffect } from "react";
import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import routes from "./config";
import MaintenanceGate from "../components/MaintenanceGate";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const hasWindow = typeof window !== "undefined";

  useEffect(() => {
    if (!hasWindow) {
      return;
    }

    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate;
      navigateResolver(window.REACT_APP_NAVIGATE);
    }
  }, [hasWindow, navigate]);

  if (!element) {
    return null;
  }

  return createElement(MaintenanceGate, { children: createElement(Suspense, { fallback: null, children: element }) });
}
